export const convertData = function (data, geoCoordMap) {
  let res = []
  for (let i = 0; i < data.length; i++) {
    let geoCoord = geoCoordMap[data[i].name]
    if (geoCoord) {
      res.push({
        name: data[i].name,
        value: geoCoord.concat(data[i].value),
        quantity: data[i].quantity,
        chargeFee: data[i].chargeFee,
        chargeTimes: data[i].chargeTimes
      })
    }
  }
  return res
}



// WEBPACK FOOTER //
// ./src/components/China/mapData.js